module.exports = __webpack_public_path__ + "img/img8.e2107046.jpg";